import dayjs from 'dayjs'

import { yearMonthDaySlash } from 'src/libs'

export const calculateGestationalAge = (lmp: string): number => {
  return dayjs().diff(dayjs(lmp), 'week')
}

export const calculateEstimatedDueDate = (lmp: string): string => {
  return dayjs(lmp).add(280, 'day').format(yearMonthDaySlash)
}

export const calculateLmpFromGestationalAge = (weeks: number): string => {
  return dayjs().subtract(weeks, 'week').format(yearMonthDaySlash)
}
